import client from "./requestclient";

const vendorJobs = {
  addService: async (addServicePayload) => {
    return await client({
      URL_PATH: `vendor-add-service`,
      method: "POST",
      body: addServicePayload,
    });
  },

  currentJobs: async (currentJobsPayload) => {
    return await client({
      URL_PATH: `vendor-current-jobs`,
      method: "POST",
      body: currentJobsPayload,
    });
  },
  newRequests: async (newRequestPayload) => {
    return await client({
      URL_PATH: `vendor-new-request-jobs`,
      method: "POST",
      body: newRequestPayload,
    });
  },
  jobsHistory: async (jobsHistoryPayload) => {
    return await client({
      URL_PATH: `vendor-jobs-history`,
      method: "POST",
      body: jobsHistoryPayload,
    });
  },

  allJobs: async (allJobsPayload) => {
    return await client({
      URL_PATH: `vendor-all-jobs`,
      method: "POST",
      body: allJobsPayload,
    });
  },

  vendorResponse: async (respondToWorkPayload) => {
    return await client({
      URL_PATH: `vendor-respond-to-work`,
      method: "POST",
      body: respondToWorkPayload,
    });
  },

  jobDetails: async (jobDetailsPayload, id) => {
    return await client({
      URL_PATH: `get-vendor-job-details/${id}`,
      method: "POST",
      body: jobDetailsPayload,
    });
  },

  rescheduleJob: async (rescheduleJobPayload) => {
    return await client({
      URL_PATH: `vendor-reschedule-job`,
      method: "POST",
      body: rescheduleJobPayload,
    });
  },

  fetchRescheduleJob: async (fetchRescheduledJobPayload) => {
    return await client({
      URL_PATH: `vendor-fetch-rescheduled-jobs`,
      method: "POST",
      body: fetchRescheduledJobPayload,
    });
  },
};

export default vendorJobs;
